import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useLoginForm } from "@hooks/useLoginForm";
import { AuthContext } from "@context/AuthContext";
import LoginFormAlerts from "@components/Form/LoginFormAlerts";
import Button from "@components/Ui/Button";
import Spinner from "@components/Ui/Spinner";
import TextInputLabel from "@components/Ui/TextInputLabel";

const LoginFormBase = ({
                           onSubmit,
                           extraSubmitFields,
                           displayEmail = false,
                           disabled = false,
                           header = null,
                           footer = null,
                           showForgotPasswordLink = true,
                       }) => {
    const { isLoginSubmitting } = useContext(AuthContext);
    const {
        username, password,
        handleUsernameChange, handlePasswordChange,
        handleSubmit, showError, loginError, successMessage,
    } = useLoginForm({ onSubmit: (creds) => onSubmit({ ...creds, ...extraSubmitFields }) });

    return (
        <>
            {header}
            <form onSubmit={handleSubmit} className="form__content">
                <TextInputLabel
                    type="email"
                    name="email"
                    labelName="Email"
                    required
                    value={username}
                    onChange={handleUsernameChange}
                />
                <TextInputLabel
                    type="password"
                    name="password"
                    labelName="Password"
                    autoComplete="true"
                    required
                    value={password}
                    onChange={handlePasswordChange}
                />
                {showForgotPasswordLink && (
                    <Link className="link link__primary" to="/request-password-reset">
                        Forgot password?
                    </Link>
                )}
                <Button additionalClasses="button button__primary" disabled={disabled}>
                    {isLoginSubmitting ? <Spinner text="loading..." /> : <span>Login</span>}
                </Button>
            </form>
            {footer}
            <LoginFormAlerts
                loginError={loginError}
                successMessage={successMessage}
                showError={showError}
                displayEmail={displayEmail}
            />
        </>
    );
};

export default LoginFormBase;
